<div class="container">
    <img src="{{image}}">
    <p>{{description}}</p>
</div>